import React, { Fragment, useRef } from "react";
import { useField } from "formik";
import SecondaryButton from "components/Buttons/SecondaryButton";
import { packClasses } from "Utils";

function FileMetaProperty(props) {
    const formikField = useField(props);
    const field = formikField[0];
    const helpers = formikField[2];

    const fileRef = useRef();

    const onChange = (e) => {
        const file = e.target.files[0];
        if (!file) {
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const contents = e.target.result;

            helpers.setValue({
                name: file.name,
                file: contents,
            });
        };
        reader.readAsDataURL(file);
    };

    return (
        <Fragment>
            <input type="hidden" name={props.name} />
            <input
                type="file"
                ref={fileRef}
                onChange={onChange}
                className="hidden"
            />
            <div className={packClasses("mt-1")}>
                {field.value?.uuid && (
                    <span className="text-xs text-gray-800">
                        Currently selected file:{" "}
                        <strong>{field.value.name}</strong>
                    </span>
                )}
                {field.value?.file && (
                    <span className="text-xs text-gray-800">
                        Currently selected file:{" "}
                        <strong>{field.value.name}</strong>
                    </span>
                )}
                {!field.value && (
                    <span className="text-xs text-gray-800">
                        No file selected
                    </span>
                )}
            </div>
            <SecondaryButton
                onClick={() => fileRef.current.click()}
                className="mt-1"
            >
                Select {field.value?.uuid ? " another " : " a "} file
            </SecondaryButton>
        </Fragment>
    );
}

export default FileMetaProperty;

export const Property = FileMetaProperty;

export const Label = "File Upload";
